<template>
  <div class="sections">
    <section id="start" class="uk-margin-large-top uk-margin-medium-bottom">
      <div class="uk-container uk-container-large">
        <div class="uk-align-center uk-width-2-3@m">
          <router-link to="/" class="uk-button-text uk-text-bold"><span class="uk-margin-small-right" data-uk-icon="chevron-left"></span>zur&uuml;ck</router-link>
          <h1 class="uk-h2">{{donation.title}}</h1>
          <div id="donation-text" v-html="donation.body_text"></div>
          <div id="betterplace_donation_iframe" style="background: transparent url('https://www.betterplace.org/assets/new_spinner.gif') 275px 20px no-repeat;"><strong><a href="https://www.betterplace.org/de/donate/platform/projects/74282-gute-stimmung-orgelklang-im-freiburger-munster">Jetzt Spenden für „Gute Stimmung: Orgelklang im Freiburger Münster“ bei unserem Partner betterplace.org</a></strong></div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import {DONATION} from '../../constants/graphql'

export default {
  name: 'DonationPage',
  data () {
    return {
      donation: {}
    }
  },
  apollo: {
    donation: {
      query: DONATION,
      update (data) {
        return data.donation.list[0]
      }
    }
  },
  created: () => {
    console.info('created')
    /* eslint-disable camelcase */
    // eslint-disable-next-line no-use-before-define
    window._bp_iframe = window._bp_iframe || {}
    window._bp_iframe.project_id = 74282 /* REQUIRED */
    window._bp_iframe.lang = 'de' /* Language of the form */
    window._bp_iframe.width = 600 /* Custom iframe-tag-width, integer */
    window._bp_iframe.color = '3399ff' /* Button and banderole color, hex without "#" */
    window._bp_iframe.background_color = 'ffffff' /* Background-color, hex without "#" */
    window._bp_iframe.default_amount = 50 /* Donation-amount, integer 1-99 */
    window._bp_iframe.recurring_interval = 'single' /* Interval for recurring donations, string out of ["single", "monthly", "quarter_yearly", "half_yearly", "yearly"] */
    window._bp_iframe.bottom_logo = true;
    (function () {
      var bp = document.createElement('script'); bp.type = 'text/javascript'; bp.async = true
      bp.src = 'https://betterplace-assets.betterplace.org/assets/load_donation_iframe.js'
      var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(bp, s)
    })()
  }
}
</script>

<style lang="scss" scoped>
  #betterplace_donation_iframe {
    margin-top: 5em;
    margin-bottom: 5em;
  }
  [data-uk-icon*="chevron"] {
    svg {
      polyline {
        stroke-width: 3px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/DonationPage/DonationPage.vue